export const META_PIXEL_ID = '1038827832097765';

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

const SCRIPT_ID = 'meta-pixel-script';

/**
 * Injects the Meta Pixel base code once and fires the initial PageView.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return;

  if (!window.fbq) {
    const fbq: Fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue?.push(args);
      }
    } as Fbq;

    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';

    window.fbq = fbq;
    window._fbq = window._fbq || fbq;
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.alt = '';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);

    window.fbq?.('init', META_PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }
}

/**
 * Fires a standard or custom Meta Pixel event.
 */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, params);
}
